import * as React from 'react';

import * as hooks from './hooks';
import {enhance} from './enhancer';
import {SalesForm} from './../../../components/Sales';
import {setState} from './stete';
import {lifecycle} from './lifecycle';
import {handler} from './handler';

function Edit(props: any) {
  const state = setState();
  lifecycle.componentDidMount(props);
  hooks.useComponentDidMount(props);

  return (
    <div className="a__sales-edit">
      <div className="b__title c__after-title">
        <h1>出品商品の詳細</h1>
      </div>
      <div className="b__form">
        <SalesForm edit {...{...props, ...state, ...handler}} />
      </div>
    </div>
  );
}

export default enhance((props: any) => <Edit {...props} />);
